/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Upgrade_ButtonInputs */



/**
* | output |
* | --- |
* | "Upgrade to Pro" |
*
* @param {Agent_Upgrade_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const agent_upgrade_button = /** @type {((inputs?: Agent_Upgrade_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Upgrade_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Passer à Pro")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf Pro upgraden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Passa a Pro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти на Pro")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pasar a Pro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("升级到 Pro")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Pro にアップグレード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Pro पर अपग्रेड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mudar para Pro")
	return /** @type {LocalizedString} */ ("Upgrade to Pro")
});